import React, { useState, useEffect, useRef } from 'react';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Skeleton } from 'primereact/skeleton';
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProductService } from '../service/ProductService';
import Utils from '../Utils';
import Axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import Config from '../config';

const last7Days = _.map(_.range(30), i => moment().subtract(30-i-1, 'days').format('D MMM'));

const lineData = {
    orders: {
        labels: last7Days,
        datasets: [
            {
                label: 'Ordini importati',
                data: [],
                fill: false,
                backgroundColor: '#2f4860',
                borderColor: '#2f4860',
                tension: .4
            }
        ]
    },
    products: {
        labels: last7Days,
        datasets: [
            {
                label: 'Prodotti aggiornati',
                data: [],
                fill: false,
                backgroundColor: '#00bb7e',
                borderColor: '#00bb7e',
                tension: .4
            }
        ]
    }
};

const Dashboard = (props) => {
    const [products, setProducts] = useState(null);
    const menu1 = useRef(null);
    const menu2 = useRef(null);
    const [lineOptions, setLineOptions] = useState(null)
    const [statsGestionale, setStatsGestionale] = useState();
    const [statsWholesalers, setStatsWholesalers] = useState();
    const [statsLogs, setStatsLogs] = useState();

    const chartOrdersRef = useRef();
    const chartProductsRef = useRef();

    useEffect(() => {
        Axios.get(Config.API_BASE_URL+'/api/stats/gestionale')
            .then(result => result.data)
            .then(result => {
                setStatsGestionale(result.data);
            });

        Axios.get(Config.API_BASE_URL+'/api/stats/wholesalers')
            .then(result => result.data)
            .then(result => {
                setStatsWholesalers(result.data);
            });

        Axios.get(Config.API_BASE_URL+'/api/stats/logs')
            .then(result => result.data)
            .then(result => {
                setStatsLogs(result.data);
            });
    }, []);

    useEffect(() => {
        if (statsLogs) {
            var orders = {};
            _.map(statsLogs.orders.syncs_per_day, (value, date) => {
                /*
                var total_price = _.sum(_.map(row.messages, message => (
                    _.sum(_.map(message, log => parseFloat(log.context.total_price)))
                )));
                */
                var end = moment(date).format('D MMM');
                orders[end] = _.defaultTo(orders[end], 0) + value;
            });

            var products = {};
            _.map(statsLogs.products.syncs_per_day, (value, date) => {
                var end = moment(date).format('D MMM');
                products[end] = value;
            });

            lineData.orders.datasets[0].data = last7Days.map(day => _.defaultTo(orders[day], 0));
            lineData.products.datasets[0].data = last7Days.map(day => _.defaultTo(products[day], 0));

            //chartOrdersRef.current.refresh();
            chartProductsRef.current.refresh();
        }
    }, [statsLogs]);

    const wholesalersColors = {
      Guacci: 'orange',
      Sofarma: 'cyan',
      Congedo: 'pink',
      Farvima: 'green',
      Vim: 'yellow',
      Cef: 'purple'
    };

    /*
    const applyLightTheme = () => {
        const lineOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef',
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef',
                    }
                },
            }
        };

        setLineOptions(lineOptions)
    }

    const applyDarkTheme = () => {
        const lineOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#ebedef'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#ebedef'
                    },
                    grid: {
                        color: 'rgba(160, 167, 181, .3)',
                    }
                },
                y: {
                    ticks: {
                        color: '#ebedef'
                    },
                    grid: {
                        color: 'rgba(160, 167, 181, .3)',
                    }
                },
            }
        };

        setLineOptions(lineOptions)
    }

    useEffect(() => {
        const productService = new ProductService();
        productService.getProductsSmall().then(data => setProducts(data));
    }, []);

    useEffect(() => {
        if (props.colorMode === 'light') {
            applyLightTheme();
        } else {
            applyDarkTheme();
        }
    }, [props.colorMode]);
    */

    /*
    const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    };
    */

    const getTotalOrders = () => {
        return _.sum(_.map(statsLogs.orders.last_syncs, row => row.messages_tot));
    };

    const getTotalPriceOrders = () => {
        if (statsLogs.orders.last_syncs.length === 0) {
            return Utils.formatCurrency(0);
        }

        return Utils.formatCurrency(
            _.sum(_.map(statsLogs.orders.last_syncs, order => order.total_price))
        );
    };

    const getTotalPriceLastOrders = () => {
        if (statsLogs.orders.length === 0) {
            return Utils.formatCurrency(0);
        }

        return Utils.formatCurrency(
            _.sum(_.map(_.get(statsLogs.orders, [0, 'messages'], []), message => (
                _.sum(_.map(message, row => parseFloat(row.context.total_price)))
            )))
        );
    };

    return (
        <div className="grid">
            {/*
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Ordini</span>
                            <div className="text-900 font-medium text-xl">
                              {statsLogs
                                ? getTotalOrders()
                                : <Skeleton width="5rem" className="mb-2"></Skeleton>
                              }
                            </div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-blue-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-shopping-cart text-blue-500 text-xl"/>
                        </div>
                    </div>
                    {statsLogs
                      ? <>
                          <span className="text-green-500 font-medium">{_.get(statsLogs.orders.last_syncs, [0, 'messages_tot'], 0)} nuovi </span>
                          <span className="text-500">nell'ultima importazione</span>
                        </>
                      : <Skeleton width="10rem" className="mb-2"></Skeleton>
                    }
                </div>
            </div>
            <div className="col-12 lg:col-6 xl:col-3">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Ricavi</span>
                            <div className="text-900 font-medium text-xl">
                              {statsLogs
                                ? getTotalPriceOrders()
                                : <Skeleton width="5rem" className="mb-2"></Skeleton>
                              }
                            </div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-orange-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-map-marker text-orange-500 text-xl"/>
                        </div>
                    </div>
                    {statsLogs
                      ? <>
                          <span className="text-green-500 font-medium">+{Utils.formatCurrency(_.get(statsLogs.orders.last_syncs, [0, 'total_price'], 0))} </span>
                          <span className="text-500">nell'ultima importazione</span>
                        </>
                      : <Skeleton width="10rem" className="mb-2"></Skeleton>
                    }
                </div>
            </div>
            */}
            <div className="col-12 md:col-6">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Prodotti gestiti</span>
                            <div className="text-900 font-medium text-xl">
                              {statsGestionale
                                ? statsGestionale.tot
                                : <Skeleton width="5rem" className="mb-2"></Skeleton>
                              }
                            </div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-cyan-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-inbox text-cyan-500 text-xl"/>
                        </div>
                    </div>
                    {statsLogs
                      ? <>
                          <span className="text-green-500 font-medium">{statsLogs.products.last_syncs[0].messages_tot} </span>
                          <span className="text-500">prodotti aggiornati alle</span>
                          <span className="text-green-500 font-medium"> {moment(statsLogs.products.last_syncs[0].end).format('HH:mm')}</span>
                        </>
                      : <Skeleton width="10rem" className="mb-2"></Skeleton>
                    }
                </div>
            </div>
            <div className="col-12 md:col-6">
                <div className="card mb-0">
                    <div className="flex justify-content-between mb-3">
                        <div>
                            <span className="block text-500 font-medium mb-3">Grossisti</span>
                            <div className="text-900 font-medium text-xl">
                              {statsWholesalers
                                ? Object.keys(statsWholesalers.tot_per_wholesaler).length
                                : <Skeleton width="1rem" className="mb-2"></Skeleton>
                              }
                            </div>
                        </div>
                        <div className="flex align-items-center justify-content-center bg-purple-100 border-round" style={{width: '2.5rem', height: '2.5rem'}}>
                            <i className="pi pi-comment text-purple-500 text-xl"/>
                        </div>
                    </div>
                    {statsWholesalers
                      ? <>
                        <span className="text-green-500 font-medium">{statsWholesalers.tot} </span>
                        <span className="text-500">prodotti unici</span>
                      </>
                      : <Skeleton width="10rem" className="mb-2"></Skeleton>
                    }
                </div>
            </div>

            {/*
            <div className="col-12 xl:col-6">
                <div className="card">
                    <h5>Andamento ordini</h5>
                    <Chart ref={chartOrdersRef} type="line" data={lineData.orders} options={lineOptions} />
                </div>

                <div className="card">
                    <h5>Ultimi ordini importati</h5>
                    <DataTable
                      loading={!statsLogs}
                      value={statsLogs ? _.map(statsLogs.orders.last_orders, order => JSON.parse(order.context)) : []}
                      responsiveLayout="scroll"
                    >
                        <Column field="id" header="ID" sortable style={{width: '15%'}} />
                        <Column field="source" header="Origine" sortable style={{width: '15%'}} />
                        <Column field="customer.name" header="Cliente" />
                        <Column field="total_price" header="Prezzo" sortable style={{width: '15%'}}/>
                    </DataTable>
                </div>
            </div>
            */}

            <div className="col-12">
                <div className="card">
                    <h5>Andamento prodotti</h5>
                    <Chart ref={chartProductsRef} type="line" data={lineData.products} options={lineOptions} />
                </div>
            </div>

            <div className="col-12 xl:col-6">
                <div className="card">
                    <div className="flex align-items-center justify-content-between mb-4">
                        <h5>Notifiche</h5>
                        {/*
                        <div>
                            <Button type="button" icon="pi pi-ellipsis-v" className="p-button-rounded p-button-text p-button-plain" onClick={(event) => menu2.current.toggle(event)}/>
                            <Menu ref={menu2} popup model={[{label: 'Add New', icon: 'pi pi-fw pi-plus'}, {label: 'Remove', icon: 'pi pi-fw pi-minus'}]}/>
                        </div>
                        */}
                    </div>

                    <span className="block text-600 font-medium mb-3">PRODOTTI</span>
                    <ul className="p-0 mx-0 mt-0 mb-4 list-none">
                        {statsLogs
                          ? <>
                              {_.map(statsLogs.products.last_syncs.slice(0, 5), data => {
                                return (
                                  <li className="flex align-items-center py-2 border-bottom-1 surface-border">
                                    <div className="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                                      <i className="pi pi-dollar text-xl text-blue-500"/>
                                    </div>
                                    <span className="text-900 line-height-3">{moment(data.end).format('D MMM - HH:mm')}
                                      <span className="text-700"> ha aggiornato <span className="text-blue-500 font-medium">{data.messages_tot} prodotti</span></span>
                                    </span>
                                  </li>
                                );
                              })}
                            </>
                          : _.map(_.range(0, 5), i => (
                              <li className="flex align-items-center py-2 border-bottom-1 surface-border">
                                <Skeleton width="10rem" className="mb-2"></Skeleton>
                              </li>
                            ))
                        }
                    </ul>

                    {/*
                    <span className="block text-600 font-medium mb-3">ORDINI</span>
                    <ul className="p-0 m-0 list-none">
                      {statsLogs
                        ? <>
                            {_.map(statsLogs.orders.last_syncs.slice(0, 5), data => {
                              return (
                                <li className="flex align-items-center py-2 border-bottom-1 surface-border">
                                  <div className="w-3rem h-3rem flex align-items-center justify-content-center bg-orange-100 border-circle mr-3 flex-shrink-0">
                                    <i className="pi pi-download text-xl text-orange-500"/>
                                  </div>
                                  <span className="text-900 line-height-3">{moment(data.end).format('D MMM - HH:mm')}
                                    <span className="text-700"> ha imporato <span className="text-blue-500 font-medium">{data.messages_tot} ordini</span></span>
                                  </span>
                                </li>
                              );
                            })}
                          </>
                        : _.map(_.range(0, 5), i => (
                            <li className="flex align-items-center py-2 border-bottom-1 surface-border">
                              <Skeleton width="10rem" className="mb-2"></Skeleton>
                            </li>
                          ))
                      }
                    </ul>
                    */}
                </div>
            </div>
            <div className="col-12 xl:col-6">
                <div className="card">
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>Sincronizzazioni per grossista</h5>
                        {/*
                        <div>
                            <Button type="button" icon="pi pi-ellipsis-v" className="p-button-rounded p-button-text p-button-plain" onClick={(event) => menu1.current.toggle(event)}/>
                            <Menu ref={menu1} popup model={[{ label: 'Add New', icon: 'pi pi-fw pi-plus' }, { label: 'Remove', icon: 'pi pi-fw pi-minus' }]}/>
                        </div>
                        */}
                    </div>
                    <ul className="list-none p-0 m-0">
                        {statsWholesalers
                          ? <>
                              {/* orange, cyan, pink */}
                              {_.map(statsWholesalers.tot_per_wholesaler, (data) => {
                                const perc = _.round(data.tot / statsWholesalers.tot * 100, 2);

                                return (
                                  <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                                    <div>
                                        <span className="text-900 font-medium mr-2 mb-1 md:mb-0">{_.capitalize(data.wholesaler)}</span>
                                        <div className="mt-1 text-600">{data.tot} prodotti</div>
                                    </div>
                                    <div className="mt-2 md:mt-0 flex align-items-center">
                                        <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{height: '8px'}}>
                                            <div className={`bg-${wholesalersColors[data.wholesaler]}-500 h-full`} style={{width: `${perc}%`}}/>
                                        </div>
                                        <span className={`text-${wholesalersColors[data.wholesaler]}-500 ml-3 font-medium`} style={{ minWidth: '50px' }}>{perc}%</span>
                                    </div>
                                </li>
                                );
                              })}
                            </>
                          : <>
                            <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                              <div>
                                  <Skeleton width="5rem" className="mb-2"></Skeleton>
                                  <Skeleton width="10rem" className="mb-2"></Skeleton>
                              </div>
                              <div className="mt-2 md:mt-0 flex align-items-center">
                                  <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{height: '8px'}}>
                                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                                  </div>
                              </div>
                            </li>
                              <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                                <div>
                                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                                </div>
                                <div className="mt-2 md:mt-0 flex align-items-center">
                                    <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{height: '8px'}}>
                                      <Skeleton width="10rem" className="mb-2"></Skeleton>
                                    </div>
                                </div>
                              </li>
                              <li className="flex flex-column md:flex-row md:align-items-center md:justify-content-between mb-4">
                                <div>
                                    <Skeleton width="5rem" className="mb-2"></Skeleton>
                                    <Skeleton width="10rem" className="mb-2"></Skeleton>
                                </div>
                                <div className="mt-2 md:mt-0 flex align-items-center">
                                    <div className="surface-300 border-round overflow-hidden w-10rem lg:w-6rem" style={{height: '8px'}}>
                                      <Skeleton width="10rem" className="mb-2"></Skeleton>
                                    </div>
                                </div>
                              </li>
                            </>
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return (prevProps.location.pathname === nextProps.location.pathname) && (prevProps.colorMode === nextProps.colorMode);
};

export default React.memo(Dashboard, comparisonFn);
